import { useParams } from "common/components/Form/ParamsContext";
import { getPartnerFeedService } from "./partnerFeedApi";

export default function usePartnerFeedList() {
  const params = useParams();
  const scope = {};
  const editUrl = `partner-feeds/`;
  const service = getPartnerFeedService(scope);

  return { ...service, params, scope, editUrl };
}
